import { formatCurrency as formatCurrencyShared } from '../../../utils/formatUtils';

/**
 * Utilidades para el módulo de estadísticas
 */

export const formatCurrency = (value) => formatCurrencyShared(value);

/**
 * Formatea un número con decimales específicos
 * @param {number} value - Valor a formatear
 * @param {number} decimals - Número de decimales (default: 2)
 * @returns {string} - Valor formateado
 */
export const formatNumber = (value, decimals = 2) => {
  return (value ?? 0).toFixed(decimals);
};

/**
 * Trunca un texto si excede una longitud máxima
 * @param {string} text - Texto a truncar
 * @param {number} maxLength - Longitud máxima
 * @returns {string} - Texto truncado
 */
export const truncateText = (text, maxLength = 20) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

/**
 * Verifica si un tipo de reporte requiere modal
 * @param {string} reportType - Tipo de reporte
 * @returns {boolean} - Si requiere modal
 */
export const requiresModal = (reportType) => {
  const modalReportTypes = [
    'fees_by_order',
    'deferred_coupons',
    'issued_coupons',
    'score_ranking',
    'sales',
    'debt_balances',
    'subscribers',
  ];

  return modalReportTypes.includes(reportType);
};

/**
 * Obtiene el nombre del archivo Excel según el tipo de reporte
 * @param {string} reportType - Tipo de reporte
 * @returns {string} - Nombre del archivo
 */
export const getExcelFilename = (reportType) => {
  const filenames = {
    fees_by_order: 'CuotasPorOrden',
    deferred_coupons: 'CuponesDiferidos',
    issued_coupons: 'CuponesEmitidos',
    score_ranking: 'RankingDePuntajes',
    sales: 'ReporteVentas',
    debt_balances: 'SaldosDeDeuda',
    subscribers: 'ReporteSuscriptores',
  };

  return filenames[reportType] || 'Reporte';
};

/**
 * Formatea el número de cuotas para mostrar
 * @param {number} fee1 - Número de cuota 1
 * @param {number} fee2 - Número de cuota 2
 * @returns {string} - Cuotas formateadas
 */
export const formatFeeNumbers = (fee1, fee2) => {
  if (fee2 && fee2 !== 0) {
    return `${fee1} - ${fee2}`;
  }
  if (fee1 !== 0) {
    return `${fee1}`;
  }
  return 'Adecuación';
};

/**
 * Calcula el total de una columna en un array de resultados
 * @param {Array} results - Array de resultados
 * @param {string} column - Nombre de la columna a sumar
 * @returns {number} - Total calculado
 */
export const calculateColumnTotal = (results, column) => {
  return results.reduce((total, result) => total + (result[column] || 0), 0);
};

/**
 * Obtiene la configuración de color para una fila según el estado
 * @param {string} status - Estado del elemento
 * @returns {Object} - Configuración de estilo
 */
export const getRowStyleByStatus = (status) => {
  const statusStyles = {
    Cancelado: { backgroundColor: '#e8f5e9' },
    Pendiente: { backgroundColor: '#fff3e0' },
    Vencido: { backgroundColor: '#ffebee' },
    default: { backgroundColor: '#ffffff' },
  };

  return statusStyles[status] || statusStyles['default'];
};

/**
 * Valida los filtros del formulario
 * @param {Object} filters - Filtros a validar
 * @returns {Object} - Objeto con isValid y errores
 */
export const validateFilters = (filters) => {
  const errors = [];

  if (filters.reportType === 'not_selected') {
    errors.push('Debe seleccionar un tipo de reporte');
  }

  if (filters.dateStart && filters.dateEnd && filters.dateStart > filters.dateEnd) {
    errors.push('La fecha desde no puede ser mayor que la fecha hasta');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
